/* eslint-disable react-hooks/exhaustive-deps */
import { Modal, Typography } from "@mui/material";
import React from "react";
import {
  StyledCompletableTask,
  StyledCompletableTaskBarWrapper,
  StyledCompletableTaskIcon,
  StyledCompletableTaskIconWrapper,
  StyledCompletableTaskPopupText,
  StyledTaskTextWrapper,
} from "./styles";
import { StyledModalContainer } from "../../pages/Layout/styles";

const CompletableTask = ({
  target = 1000,
  onTarget = () => {},
  steps = 5,
  completed = false,
  icon,
  title,
  popupText,
  variant = "circle",
  data = {},
  renderModal,
  fullWidth = false,
}) => {
  const [mouseDown, setMouseDown] = React.useState(false);
  const [currentCount, setCurrentCount] = React.useState(
    completed ? target : 0
  );
  const [isDone, setIsDone] = React.useState(completed);
  const [showDescription, setShowDescription] = React.useState(false);
  const intervalRef = React.useRef();

  const onInterval = React.useCallback(() => {
    !isDone && setCurrentCount((c) => c + steps);
  }, [setCurrentCount, steps, isDone]);

  React.useEffect(() => {
    if (mouseDown) {
      if (!isDone) intervalRef.current = setInterval(onInterval, steps);
      else setShowDescription(true);
    }

    if (!mouseDown && intervalRef.current) {
      clearInterval(intervalRef.current);
      if (currentCount < target) {
        setCurrentCount(0);
        setTimeout(() => {
          setShowDescription(true);
        }, 150);
      }
    }
  }, [onInterval, target, mouseDown, steps]);

  React.useEffect(() => {
    if (currentCount >= target) {
      !isDone && onTarget();
      setIsDone(true);
      //   setCurrentCount(0);
    }
  }, [currentCount, isDone]);

  React.useEffect(
    () => () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setIsDone(false);
      }
    },
    []
  );

  const percentage =
    currentCount >= target ? 100 : Math.floor((currentCount / target) * 100);

  const handleStart = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setMouseDown(true);
  };
  const handleStop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setMouseDown(false);
  };
  const handleDoubleClick = () => setShowDescription(true);

  return (
    <>
      {renderModal && (
        <Modal open={showDescription} onClose={() => setShowDescription(false)}>
          <StyledModalContainer>
            {showDescription && renderModal(data, setShowDescription)}
          </StyledModalContainer>
        </Modal>
      )}
      <StyledCompletableTask
        onMouseDown={handleStart}
        onMouseUp={handleStop}
        onMouseLeave={handleStop}
        onMouseOut={handleStop}
        onTouchStart={handleStart}
        onTouchEnd={handleStop}
        onDoubleClick={handleDoubleClick}
      >
        {variant === "circle" ? (
          <StyledTaskTextWrapper>
            <StyledCompletableTaskIconWrapper $percentage={percentage}>
              <StyledCompletableTaskIcon>
                <Typography variant="h3">{icon}</Typography>
              </StyledCompletableTaskIcon>
            </StyledCompletableTaskIconWrapper>
            <Typography variant="body2">{title}</Typography>
            {popupText ? (
              <StyledCompletableTaskPopupText>
                <Typography variant="caption">{popupText}</Typography>
              </StyledCompletableTaskPopupText>
            ) : null}
          </StyledTaskTextWrapper>
        ) : (
          <StyledCompletableTaskBarWrapper
            $fullWidth={fullWidth}
            $percentage={percentage}
          >
            <Typography variant="body1">{title}</Typography>
          </StyledCompletableTaskBarWrapper>
        )}
      </StyledCompletableTask>
    </>
  );
};

export default CompletableTask;
